module.exports = __webpack_public_path__ + "img/99.1.be3451d0.jpg";